const uiExceptions = {
    'arrow-up-left-straight': 'arrow-up-left',
    'arrow-up-right-straight': 'arrow-up-right',
    share_ios: 'share-ios',
    OV: 'ov',
};
export const getCorrectVariant = (type, variant) => {
    if (type === 'ui' && uiExceptions[variant]) {
        const correctVariant = uiExceptions[variant];
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
            // eslint-disable-next-line no-console
            console.warn(`DEPRECATION WARNING: Icon variant "${variant}" is deprecated. Please use "${correctVariant}".`);
        }
        return correctVariant;
    }
    return variant;
};
//# sourceMappingURL=getCorrectVariant.js.map